// Path: ./src/app/components/CreateRoleCard/index.tsx
import { Grid } from "@mui/material";
import React from "react";
import { AccountCardWrapper } from "../AccountCardWrapper";
import { PermissionSelectTable } from "../PermissionSelectTable";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import {
  CancelButton,
  ColorButton,
} from "../../../utils/commonStyledComponents/commonMuiStyled";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";
import { PermissionGroupTableWrapper } from "./styled";
import {
  ButtonWrapper,
  InputLabelText,
  Wrapper,
} from "../../components/AccountPageCreatePageCommon";

interface Props {
  cardTitle: string;
  CancelButtonText: string;
  FinishButtonText: string;
  disabledFinishButton?: boolean;
  /**
   * Callback function to handle the creation of a new role.
   * This function is invoked when a "Finish" or "Create" button is clicked to create a new role.
   */
  onClickFinish?: () => void;
  /**
   * Callback function to handle canceling the creation process for a role.
   * This function is invoked when a "Cancel" button  clicked.
   */
  onClickCancel?: () => void;
  handleInputText?: () => void;
  inputTextValue?: string;
  PermissionRowData1?: {
    title: string;
    isChecked: boolean;
    handleChange: () => void;
    dataTestId: string;
    itemsList: {
      isChecked: boolean;
      dataTestId: string;
      title: string;
      includeTextInput?: boolean;
      onClick?: () => void;
    }[];
  }[];
  PermissionRowData2?: {
    title: string;
    isChecked: boolean;
    dataTestId: string;

    handleChange: () => void;
    itemsList: {
      isChecked: boolean;
      dataTestId: string;
      title: string;
      includeTextInput?: boolean;
      onClick?: () => void;
    }[];
  }[];
}
export const CreateRoleCard = ({
  cardTitle,
  CancelButtonText,
  FinishButtonText,
  onClickCancel,
  onClickFinish,
  PermissionRowData1,
  PermissionRowData2,
  handleInputText,
  inputTextValue,
  disabledFinishButton,
}: Props) => {
  const { t } = useTranslation();
  return (
    <AccountCardWrapper title={cardTitle} data-testid="createrolecard-test-id">
      <Grid container spacing={2} style={{ padding: 20, marginTop: 10 }}>
        <Grid
          item
          xs={12}
          md={12}
          style={{
            width: "100%",
          }}
        >
          <Wrapper
            customStyles={{
              justifyContent: "start",
            }}
          >
            <InputLabelText
              customStyles={{
                fontSize: "20px",
              }}
            >
              {t(messages.Name_of_The_Role())}{" "}
            </InputLabelText>
            <TextInputField
              value={inputTextValue}
              type="text"
              onChange={handleInputText}
              data-testid="create-role-name-input"
            />
          </Wrapper>
        </Grid>
        <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
          <Wrapper
            customStyles={{
              justifyContent: "start",
            }}
          >
            <InputLabelText
              customStyles={{
                fontSize: "20px",
              }}
            >
              {t(messages.Permission_Groups())}
            </InputLabelText>
          </Wrapper>
        </Grid>
        <Grid item xs={12} md={12}>
          <PermissionGroupTableWrapper>
            {PermissionRowData1?.map((value) => {
              return (
                <PermissionSelectTable
                  key={value.title}
                  title={value.title}
                  isChecked={value.isChecked}
                  handleChange={value.handleChange}
                  itemsList={value.itemsList}
                  dataTestId={value?.dataTestId}
                  data-testid="createrolecard-test-id"
                />
              );
            })}
          </PermissionGroupTableWrapper>
        </Grid>
        <Grid item xs={12} md={12}>
          <PermissionGroupTableWrapper>
            {PermissionRowData2?.map((value) => {
              return (
                <PermissionSelectTable
                  key={value.title}
                  title={value.title}
                  isChecked={value.isChecked}
                  handleChange={value.handleChange}
                  itemsList={value.itemsList}
                  dataTestId={value?.dataTestId}
                  data-testid="createrolecard-test-id"
                />
              );
            })}
          </PermissionGroupTableWrapper>
        </Grid>
        <Grid item xs={12}>
          <ButtonWrapper>
            <CancelButton
              variant="contained"
              onClick={onClickCancel}
              data-testid="create-role-cancel-button"
            >
              {CancelButtonText}
            </CancelButton>
            <ColorButton
              variant="contained"
              onClick={onClickFinish}
              disabled={disabledFinishButton}
              data-testid="create-role-finish-button"
            >
              {FinishButtonText}
            </ColorButton>
          </ButtonWrapper>
        </Grid>
      </Grid>
    </AccountCardWrapper>
  );
};
